import { RecommendationCropwiseResponse } from 'base/types/RecommendationCropwise';

/**
 * Checks if a recommendation was generated by a script
 * @param recommendationCropwise - The recommendation data
 * @returns true if the recommendation was script-generated, false otherwise
 */
export const isScriptGenerated = (
  recommendationCropwise: RecommendationCropwiseResponse | null | undefined
): boolean => {
  return (
    recommendationCropwise?.recommendations?.[0]?.multi_field?.config?.agronomicInputs
      ?.generatedby === 'script'
  );
};

export const isFranceBarleyScriptGenerated = (
  recommendationCropwise: RecommendationCropwiseResponse | null | undefined
): boolean =>
  isScriptGenerated(recommendationCropwise) &&
  recommendationCropwise?.country?.trim().toLowerCase() === 'france' &&
  recommendationCropwise?.recommendations?.[0]?.crop_name?.trim().toLowerCase() === 'barley';
